import Home from "@/components/Home.vue";

export default [
  // {path: '/', component: Upload, name: 'root'},
  {path: '/', component: Home, name: 'root'},
]
